import { hasMany, type AsyncHasMany } from '@ember-data/model';
import DeviceConfigStaticPageModel from 'garaje/models/device-config-static-page';
import type DeviceConfigStaticPageAttributeModel from 'garaje/models/device-config-static-page-attribute';

export default class PropertyAssistanceScreenModel extends DeviceConfigStaticPageModel {
  @hasMany('device-config-static-page-attribute', { async: true, inverse: null })
  declare deviceConfigStaticPageAttributes: AsyncHasMany<DeviceConfigStaticPageAttributeModel>;
}
